const imageURL = 'https://res.cloudinary.com/dagb9zfyf/image/upload/v1697996226/Food31_ssnla6.jpg';
const fillTypeOne = "thumb";
const width = 300;
const height = 300;

const imageUrlTransformation = ({ imageUrl, fillType, width, height }) => {
    try {
        if (!fillType || (fillType && !['fill', 'thumb'].includes(fillType))) {
            return 'fillType can be either one [fill & thumb]'
        }

        if (imageUrl && imageUrl.length > 0 && fillType) {
            const w = width ? `w_${width}` : '';
            const h = height ? `h_${height}` : '';
            let format = '';
            if (width && height) {
                format = `c_${fillType},${w},${h}`
            } else if (width && !height) {
                format = `c_${fillType},${w}`
            } else if (height && !width) {
                format = `c_${fillType},${h}`
            } else if (!width && !height) {
                return imageUrl
            }
            const first = imageUrl.substring(0, imageUrl.indexOf('/v'));
            const second = imageUrl.substring(imageUrl.indexOf('/v'));
            const splitStr = second.split('/')
            splitStr[1] = format

            return first + splitStr.join('/')
        } else {
            return
        }
    } catch (error) {
        console.log('Errorin imageTranformation method', error)
    }

}


export default imageUrlTransformation

// console.log('-----', imageTranformation({ imageUrl: imageURL, width: width, fillType: fillTypeOne, height: height }))